import React from 'react';
import css from '../less/card.m.less';
import {formatter} from '@ab/components';
import cx from 'classnames';

export default function template() {
    const model = this.getModel(),
        {active, newCardAttr} = this.props;

    return (
        <div className={css.wrap}>
            <div
                className={cx(css.block, {
                    [css.card]:
                        model.get('descriptionStatus') && model.get('descriptionStatus').errorCode,
                })}
            >
                <div className={cx(css.lock)} />
                <span>{this.l10n('DASHBOARD_WALLET_CARD_HAS_BLOCK')}</span>
            </div>
            <div
                className={cx(css.root, {[css.active]: active})}
                style={{
                    backgroundImage: newCardAttr?.design?.tone
                        ? `url("${newCardAttr.design.tone}"), url("${newCardAttr.design.skin}")`
                        : newCardAttr?.design?.skin
                        ? `url("${newCardAttr.design.skin}")`
                        : model.img(),
                    backgroundSize: newCardAttr?.design?.tone ? 'cover, cover' : 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                }}
            >
                <div className={css.heading}>
                    <div className={css.balanceWrapper}>
                        <span className={css.balance}>
                            {model.get('balance') &&
                                model.get('balance').toString(null, null, true)}
                        </span>
                        &nbsp;
                        <span>{model.get('currency') && model.get('currency').getSymbol()}</span>
                    </div>
                    <div>{formatter(model.get('expd'), '{{dd}}/{{dd}}')}</div>
                </div>
                <div className={css.body}>
                    <div className={css.content}>
                        <div className={cx(css.number, 'swiper-no-swiping')}>
                            {this.state.pan && active
                                ? this.state.pan.toString()
                                : newCardAttr?.number
                                ? newCardAttr.number
                                : model.mask()}
                        </div>
                        <div className={css.name}>{model.get('name')}</div>
                        {newCardAttr.account_name && active ? (
                            <div className={css.accountName}>{newCardAttr.account_name}</div>
                        ) : null}
                    </div>
                    <div>
                        <img
                            className={cx(css.issuer)}
                            alt={this.l10n('DASHBOARD_WALLET_CARD_ISSUER')}
                            src={
                                newCardAttr?.design?.mps ? newCardAttr.design.mps : model.img('mps')
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
